(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-expiry-date"] && !Shopify.designMode) return;
  try {
    class VariantExpiryDate extends HTMLElement {
    connectedCallback() {
      this._expiryMap = null;
      this._hideWhenEmpty = this.style.cssText.includes('display: none') === false
        ? this.dataset.hideWhenEmpty === 'true'
        : true;

      try {
        const mapEl = this.querySelector('.variant-expiry-map');
        if (mapEl) 
          this._expiryMap = JSON.parse(mapEl.textContent);
        
      } catch (e) {
        console.warn('[VariantExpiryDate] Could not parse expiry map', e);
      }

      const section = this.closest('.shopify-section');
      if (section) {
        section.addEventListener('variant:update', this._handleVariantUpdate);
      }
    }

    disconnectedCallback() {
      const section = this.closest('.shopify-section');
      if (section) {
        section.removeEventListener('variant:update', this._handleVariantUpdate);
      }
    }

    _handleVariantUpdate = (event) => {
      const variantId = event.detail ?. resource ?. id;
      if (! variantId || !this._expiryMap) return;
      

      const value = this._expiryMap[String(variantId)] || '';
      const valueEl = this.querySelector('.variant-expiry-date__value');
      if (valueEl) 
        valueEl.textContent = value;
      

// Show/hide based on whether there's a value
      if (this.dataset.hideWhenEmpty === 'true') {
        this.style.display = value
          ? ''
          : 'none';
      }
    };
  }

  if (!customElements.get('variant-expiry-date')) {
    customElements.define('variant-expiry-date', VariantExpiryDate);
  }
  } catch(e) { console.error(e); }
})();

})();
